export const pageModel = {
    content: [],
    number: 0,
    last: true,
    first: true
}